// extracted by mini-css-extract-plugin
export var quick = "quick-module--quick--V4S+D";
export var item = "quick-module--item--yER4s";
export var fadein = "quick-module--fadein--wRSzs";